import React, { useState, useEffect } from 'react';
import { useLocation, Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import axios from 'axios';

import BwossyLogo from "../components/Layout/BwossyLogo"; 

import { 
  Button 
} from '@mui/material';

const VerifyEmail = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const email = new URLSearchParams(location.search).get("email");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const handleResendEmail = async () => {
    if (emailSent) return; // Prevent multiple clicks after success

    setLoading(true);
    setMessage("");

    try {
      // Get user consent for email tracking
      let consentTracking = false;
      if (window.klaro && typeof window.klaro.getManager === "function") {
          const manager = window.klaro.getManager();
          consentTracking = manager.getConsent("brevo") || false;
      }

      const response = await axios.post(
          `${baseURL}/api/users/resendVerificationEmail`,
          { email, consentTracking } 
      );
      setMessage(response.data.message);
      setEmailSent(true);
    } catch (error) {
        setMessage(error.response?.data?.message || t("verifyEmail.emailFailed") );
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="verify-container">
      <div className="login-logo-container">
          <a href="./">
            <span className="login-logo-name">
              <Trans i18nKey="common.appNameLogo" components={[<BwossyLogo />]} />
            </span>
          </a>
        </div>

        <div className="verify-content-container">
          <h2>{t("verifyEmail.pageTitle")}</h2>
          <p>
              {t("verifyEmail.instruction")} <b>{email}</b>. {t("verifyEmail.checkSpam")}
          </p>
          {message && <p className={`message ${emailSent ? "success" : "error"}`}>{message}</p>}

            <Button
              type="submit"
              disabled={loading || emailSent}
              onClick={handleResendEmail}
              variant="contained"
            >
              {loading ? t("verifyEmail.resending") : t("verifyEmail.resendEmail")}
              </Button>
        </div>
    </div>
  );
};

export default VerifyEmail;